module.exports = __webpack_public_path__ + "static/img/24-3.13b45bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-3.jpg
// module id = aSq4
// module chunks = 0